import { Instagram, Facebook, Youtube, Phone, MapPin, Mail } from "lucide-react";
import { CONTACT } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      id="contact"
      data-testid="footer-section"
      className="relative bg-[#0d0d09] pt-20 pb-10 border-t border-[color:var(--sh-line)]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-[color:var(--sh-amber)]" />
              <span className="sh-serif text-2xl text-[color:var(--sh-cream)]">Sardar House</span>
            </div>
            <p className="mt-5 text-[color:var(--sh-cream-dim)] max-w-md text-sm leading-relaxed">
              A boutique mountain lodge in the pine forests of Nathia Gali. Warm
              rooms, cold air, quiet nights.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[
                { icon: Instagram, label: "Instagram" },
                { icon: Facebook, label: "Facebook" },
                { icon: Youtube, label: "YouTube" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#"
                  aria-label={s.label}
                  data-testid={`social-${s.label.toLowerCase()}`}
                  className="w-10 h-10 rounded-full border border-[color:var(--sh-line)] flex items-center justify-center text-[color:var(--sh-cream-dim)] hover:text-[color:var(--sh-amber)] hover:border-[color:var(--sh-amber)] transition"
                >
                  <s.icon size={16} strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--sh-amber)] mb-4">
              Contact
            </div>
            <ul className="space-y-4 text-sm text-[color:var(--sh-cream-dim)]">
              <li className="flex items-start gap-3">
                <MapPin size={15} className="text-[color:var(--sh-amber)] mt-0.5" strokeWidth={1.5} />
                <span>{CONTACT.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={15} className="text-[color:var(--sh-amber)]" strokeWidth={1.5} />
                <a
                  href={`tel:${CONTACT.phoneRaw}`}
                  data-testid="footer-phone"
                  className="hover:text-[color:var(--sh-amber)] transition tabular-nums"
                >
                  {CONTACT.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={15} className="text-[color:var(--sh-amber)]" strokeWidth={1.5} />
                <a
                  href="mailto:hello@sardarhouse.pk"
                  className="hover:text-[color:var(--sh-amber)] transition"
                >
                  hello@sardarhouse.pk
                </a>
              </li>
            </ul>
          </div>

          {/* Explore */}
          <div className="lg:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--sh-amber)] mb-4">
              Explore
            </div>
            <ul className="space-y-3 text-sm text-[color:var(--sh-cream-dim)]">
              {[
                ["Rooms", "#rooms"],
                ["Experience", "#experience"],
                ["Amenities", "#amenities"],
                ["Gallery", "#gallery"],
                ["Book", "#book"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a href={href} className="hover:text-[color:var(--sh-amber)] transition">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* bottom bar */}
        <div className="mt-16 pt-6 border-t border-[color:var(--sh-line)] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-[color:var(--sh-cream-mute)]">
          <div>© {new Date().getFullYear()} Sardar House. All rights reserved.</div>
          <div>Nathia Gali · Pakistan</div>
        </div>
      </div>
    </footer>
  );
}
